import type { TComponentSize, TComponentVariant } from "@shared/config";
import type { FC, ReactNode } from 'react';

import './styles.scss';

// Component props interface
export interface ISpinnerProps {
  size?: TComponentSize;
  variant?: TComponentVariant; // kept for API compat, no visual effect
  className?: string;
  'aria-label'?: string;
  /** Text label rendered as a sibling below the spinner ring — does NOT rotate */
  children?: ReactNode;
}

// Component types
export type TSpinnerElement = HTMLDivElement;

export const APSpinner: FC<ISpinnerProps> = ({
  size = 'medium',
  variant: _variant = 'primary',
  className = '',
  'aria-label': ariaLabel = 'Loading...',
  children,
}) => {
  const baseClasses = 'ap-spinner';
  const sizeClass = size === 'large' ? 'ap-spinner--lg' : '';
  const allClasses = [baseClasses, sizeClass, className].filter(Boolean).join(' ');

  if (children) {
    // Wrap spinner + label so text is a sibling of the ring, not inside it
    return (
      <span style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
        <div className={allClasses} role="status" aria-label={ariaLabel} aria-live="polite" />
        <span className="ap-muted">{children}</span>
      </span>
    );
  }

  return (
    <div className={allClasses} role="status" aria-label={ariaLabel} aria-live="polite" />
  );
};

export default APSpinner;
